<template>
  <div class="flex flex-col items-center h-full">
    <div class="min-h-14 md:min-h-20 w-full">
      <LayoutHeader class="min-h-14 md:min-h-20 fixed top-0 z-[1000]" />
    </div>
    <div class="flex w-full max-w-[1440px]">
      <LayoutContainer>
        <div class="flex justify-stretch py-8">
          <slot />
        </div>
        <LayoutFooter />
      </LayoutContainer>
    </div>
  </div>
</template>
